import PulseCircleCarousel from "./PulseCircleCarousel";

export default function LogoCarousel() {
  return (
    <a
      href="#lectura"
      className="pulse-header-logo-link inline-flex shrink-0 items-center justify-center no-underline"
      aria-label="Ir al contenido"
    >
      <PulseCircleCarousel />
    </a>
  );
}
